import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconBoltSvg } from "./IconBoltSvg.mjs";
const IconBolt = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconBoltSvg, ...iconProps });
};
export {
  IconBolt
};
